import {http} from '../../plugins/http';

export default {

    index() {
        return http.get(`/api/v1/on-site-notifications/on-site-notification`);
    },

    destroy(notification) {
        return http.delete(`/api/v1/on-site-notifications/on-site-notification/${notification}`);
    }

};



// WEBPACK FOOTER //
// ./src/services/OnSiteNotifications/OnSiteNotificationsController.js